module.exports = __webpack_public_path__ + "img/icon_to_small.7eea987a.svg";